import HTML5Icon from "../assets/TechIcons/HTML5.png";
import CSS3Icon from "../assets/TechIcons/CSS3.png";
import JavascriptIcon from "../assets/TechIcons/Javascript.png";
import BootstrapIcon from "../assets/TechIcons/Bootstrap.png";
import ReactIcon from "../assets/TechIcons/React.png";
import SassIcon from "../assets/TechIcons/Sass.png";
import GitIcon from "../assets/TechIcons/Git.png";
import GithubIcon from "../assets/TechIcons/Github.png";
import ExpoIcon from "../assets/TechIcons/Expo.png";
import NodeJSIcon from "../assets/TechIcons/NodeJS.png";
import ExpressIcon from "../assets/TechIcons/Express.png";
import GeistIcon from "../assets/TechIcons/Geist.png";
import StyledComponentsIcon from "../assets/TechIcons/Styled-Components.png";

const techs = [
  {
    title: "HTML5",
    icon: HTML5Icon,
    webPage: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5",
  },
  {
    title: "CSS3",
    icon: CSS3Icon,
    webPage: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    title: "Javascript",
    icon: JavascriptIcon,
    webPage: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    title: "Bootstrap",
    icon: BootstrapIcon,
    webPage: "https://getbootstrap.com/",
  },
  {
    title: "React",
    icon: ReactIcon,

    webPage: "https://reactjs.org/",
  },
  {
    title: "Sass",
    icon: SassIcon,
    webPage: "https://sass-lang.com/",
  },
  {
    title: "Git",
    icon: GitIcon,
    webPage: "https://git-scm.com/",
  },
  {
    title: "Github",
    icon: GithubIcon,
    webPage: "https://github.com/",
    shouldInvertColorsIfNeeded: true,
  },
  {
    title: "React Native",
    icon: ReactIcon,
    webPage: "https://reactnative.dev/",
  },
  {
    title: "Expo",
    icon: ExpoIcon,
    webPage: "https://expo.io/",
    shouldInvertColorsIfNeeded: true,
  },
  {
    title: "Node.js",
    icon: NodeJSIcon,
    webPage: "https://nodejs.org/",
  },
  {
    title: "Express",
    icon: ExpressIcon,
    webPage: "https://expressjs.com",
    shouldInvertColorsIfNeeded: true,
  },
  {
    title: "Geist",
    icon: GeistIcon,
    webPage: "https://geist-ui.dev/",
  },
  {
    title: "Styled-Components",
    icon: StyledComponentsIcon,
    webPage: "https://styled-components.com/",
    shouldInvertColorsIfNeeded: true,
  },
];

export default techs;
